/* bios-player.js — YouTube playlist player with EQ bars and track display.
   Loops a curated playlist via the YouTube IFrame API. The animated bar
   meter is purely cosmetic (random walk, not real audio amplitude — the
   IFrame API does not expose PCM). Sync only happens during playback;
   when paused, bars decay to zero. */
(function () {
  var PLAYLIST_ID = 'PLKx0wmL8rbdPi9aszPvmXl6nsr7p5-yPM'; /* curated playlist, loops */
  var BAR_COUNT   = 10;

  var trackEl  = document.getElementById('bios-player-track');
  var barsEl   = document.getElementById('bios-player-bars');
  var playerEl = document.getElementById('bios-player');

  var isPlaying = false;
  var ytPlayer  = null;
  var ytAmbient = null;  /* hoisted so tryStart() below can see it; assigned by onYouTubeIframeAPIReady */
  var bars      = [];
  var ppBtn     = document.getElementById('bios-player-playpause');

  /* build visualizer bars */
  if (barsEl) {
    for (var b = 0; b < BAR_COUNT; b++) {
      var bar = document.createElement('div');
      bar.className = 'bios-player-bar';
      barsEl.appendChild(bar);
      bars.push(bar);
    }
  }

  /* ── Position-locked spectrum simulation ─────────────────────────────────
     YouTube iframes are cross-origin so the Web Audio API cannot tap their
     stream on mobile. Instead we derive beat timing from the player's own
     getCurrentTime(), which means the bars sync to the ACTUAL song position:
     the same beat always triggers at the same moment in a track.

     Band model (10 bars, left = bass, right = treble):
       0-1  sub-bass       heavy kick energy, slow decay
       2-3  bass           kick + body
       4-5  low-mid        snare attack
       6-7  mid/upper-mid  body, harmonics
       8-9  presence/air   hi-hats, transients, fast decay

     Dynamic energy: every ~24 s we shift between LOW / MED / HIGH to
     simulate verse→chorus→drop dynamics.
  ─────────────────────────────────────────────────────────────────────── */
  var _bandLvl  = [];
  for (var _bi = 0; _bi < BAR_COUNT; _bi++) _bandLvl.push(0);

  /* configurable BPM — change to match your playlist's dominant tempo */
  var _bpm       = 122;
  var _prevBeat  = -1;
  var _prevHalf  = -1;

  /* natural max heights per band — bass bars taller, treble shorter */
  var _bandMax = (function() {
    var m = [];
    for (var _i = 0; _i < BAR_COUNT; _i++) {
      /* logarithmic ramp: 10 at bass, ~4 at treble */
      m.push(10 - (_i / (BAR_COUNT - 1)) * 6);
    }
    return m;
  })();

  /* energy-section cycle — LOW / MED / HIGH every 24 s */
  var _energySection   = 1; /* 0=low, 1=med, 2=high */
  var _energyTimer     = 0;
  var _ENERGY_INTERVAL = 24; /* seconds of song time between changes */
  var _prevSongTime    = -1;

  /* shared band levels — read by the mobile pip bar loop too */
  window._biosVizBands = _bandLvl;

  (function animateBars() {
    requestAnimationFrame(animateBars);

    if (!isPlaying) {
      /* paused — fast decay to flat */
      for (var qi = 0; qi < BAR_COUNT; qi++) {
        _bandLvl[qi] = Math.max(0, _bandLvl[qi] * 0.50);
      }
      bars.forEach(function(bar, idx) {
        bar.style.height = Math.max(1, Math.round(_bandLvl[idx])) + 'px';
      });
      return;
    }

    /* ── Get actual song position from the player ── */
    var songTime = (ytPlayer && typeof ytPlayer.getCurrentTime === 'function')
                 ? ytPlayer.getCurrentTime()
                 : 0;

    /* ── Advance energy section using real song time ── */
    if (songTime > 0 && songTime !== _prevSongTime) {
      if (Math.floor(songTime / _ENERGY_INTERVAL) !== _energyTimer) {
        _energyTimer = Math.floor(songTime / _ENERGY_INTERVAL);
        /* cycle through patterns: low → med → high → high → med → low */
        var _pat = [0, 1, 2, 2, 1, 0];
        _energySection = _pat[_energyTimer % _pat.length];
      }
      _prevSongTime = songTime;
    }

    /* scale factors per energy section */
    var _eFactor = _energySection === 2 ? 1.0 : _energySection === 1 ? 0.72 : 0.45;

    /* ── Derive beat position from song time ── */
    var beatCount = songTime * _bpm / 60;
    var beatFloor = Math.floor(beatCount);
    var halfFloor = Math.floor(beatCount * 2);
    var newBeat   = (beatFloor !== _prevBeat);
    var newHalf   = (halfFloor !== _prevHalf);
    _prevBeat = beatFloor;
    _prevHalf = halfFloor;

    /* ── Per-band decay — bass holds longest, treble fastest ── */
    for (var di = 0; di < BAR_COUNT; di++) {
      var decayRate = 0.85 - (di / (BAR_COUNT - 1)) * 0.30; /* 0.85→0.55 */
      _bandLvl[di] = Math.max(0, _bandLvl[di] * decayRate);
    }

    /* ── Kick on every beat — hits sub-bass + bass ── */
    if (newBeat) {
      var kickAmt = (5.5 + Math.random() * 3.5) * _eFactor;
      _bandLvl[0] = Math.min(_bandMax[0], _bandLvl[0] + kickAmt);
      _bandLvl[1] = Math.min(_bandMax[1], _bandLvl[1] + kickAmt * 0.85);
      _bandLvl[2] = Math.min(_bandMax[2], _bandLvl[2] + kickAmt * 0.55);
      _bandLvl[3] = Math.min(_bandMax[3], _bandLvl[3] + kickAmt * 0.30);
    }

    /* ── Snare on half-beats — hits low-mid / mid ── */
    if (newHalf && !newBeat) {
      var snareAmt = (3.5 + Math.random() * 3.0) * _eFactor;
      _bandLvl[3] = Math.min(_bandMax[3], _bandLvl[3] + snareAmt * 0.40);
      _bandLvl[4] = Math.min(_bandMax[4], _bandLvl[4] + snareAmt);
      _bandLvl[5] = Math.min(_bandMax[5], _bandLvl[5] + snareAmt * 0.85);
      _bandLvl[6] = Math.min(_bandMax[6], _bandLvl[6] + snareAmt * 0.50);
    }

    /* ── Hi-hat transients — probabilistic upper bands ── */
    var hihatChance = _energySection === 2 ? 0.18 : _energySection === 1 ? 0.10 : 0.05;
    if (Math.random() < hihatChance) {
      var hiBand = 6 + Math.floor(Math.random() * 4);
      var hiAmt  = (2.0 + Math.random() * 3.5) * _eFactor;
      _bandLvl[hiBand] = Math.min(_bandMax[hiBand], _bandLvl[hiBand] + hiAmt);
    }

    /* ── Noise floor — organic movement between hits ── */
    for (var ni = 0; ni < BAR_COUNT; ni++) {
      var noiseMax = 0.35 * _eFactor;
      _bandLvl[ni] = Math.min(_bandMax[ni], _bandLvl[ni] + Math.random() * noiseMax);
    }

    bars.forEach(function(bar, idx) {
      bar.style.height = Math.max(1, Math.round(_bandLvl[idx])) + 'px';
    });
  })();

  /* play/pause button */
  if (ppBtn) {
    ppBtn.addEventListener('click', function() {
      if (!ytPlayer || typeof ytPlayer.getPlayerState !== 'function') return;
      if (ytPlayer.getPlayerState() === YT.PlayerState.PLAYING) {
        ytPlayer.pauseVideo();
      } else {
        ytPlayer.playVideo();
      }
    });
  }

  /* prev / next */
  var prevBtn = document.getElementById('bios-player-prev');
  var nextBtn = document.getElementById('bios-player-next');
  if (prevBtn) prevBtn.addEventListener('click', function() {
    if (ytPlayer && typeof ytPlayer.previousVideo === 'function') ytPlayer.previousVideo();
  });
  if (nextBtn) nextBtn.addEventListener('click', function() {
    if (ytPlayer && typeof ytPlayer.nextVideo === 'function') ytPlayer.nextVideo();
  });

  /* update track name in UI */
  function updateTrack() {
    if (!ytPlayer || typeof ytPlayer.getVideoData !== 'function') return;
    var data  = ytPlayer.getVideoData();
    var title = (data.title || '').toUpperCase();
    if (title.length > 28) title = title.slice(0, 27) + '…';
    if (trackEl) trackEl.textContent = title || '——';
  }

  /* called by YouTube API once script loads — inits ambient, music, and boot players */
  window.onYouTubeIframeAPIReady = function () {

    /* ── Ambient background drone: fixed, no UI control, always loops ── */
    ytAmbient = new YT.Player('bios-yt-ambient', {
      height: '1', width: '1',
      videoId: 'fxjIthZY3YI',
      playerVars: {
        autoplay:       1,
        loop:           1,
        playlist:       'fxjIthZY3YI',
        start:          335,          /* jump straight to the drone section */
        controls:       0,
        disablekb:      1,
        fs:             0,
        modestbranding: 1,
        playsinline:    1,
        rel:            0,
      },
      events: {
        onReady: function(e) {
          window._biosYtAmbient = e.target;
          e.target.setVolume(16);   /* fixed ambient level — not tied to volume slider */
          e.target.playVideo();
          /* notify mixer (and any other listener) that ambient is ready */
          document.dispatchEvent(new CustomEvent('bios:yt-ambient-ready'));
        },
        onStateChange: function(e) {
          /* restart from drone section if it somehow stops */
          if (e.data === YT.PlayerState.ENDED) {
            e.target.seekTo(335, true);
            e.target.playVideo();
          }
        }
      }
    });

    /* ── Cross-page music state restore ─────────────────────────────
       The YouTube iframe is destroyed on every full page navigation.
       Without intervention, the player would start fresh at the seed
       track each time the user clicks INNOCENCES, opens a product, etc.
       Fix: stash videoId + currentTime + playlistIndex in sessionStorage
       on pagehide; restore inside onReady so the new iframe seeks to
       where the old one left off.

       Why sessionStorage: scoped to the tab. Closing the tab starts a
       fresh session; same-tab navigation preserves state.
       Why pagehide (not beforeunload): mobile Safari/Chrome on iOS
       don't fire beforeunload reliably; pagehide does.
       Periodic 4s save is a fallback for cases where pagehide misses. */
    var STATE_KEY = 'bios_yt_state';
    var STATE_TTL_MS = 5 * 60 * 1000;

    function _saveYtState() {
      if (!ytPlayer || typeof ytPlayer.getCurrentTime !== 'function') return;
      try {
        var vd = ytPlayer.getVideoData ? ytPlayer.getVideoData() : null;
        var videoId = (vd && vd.video_id) || '';
        var t       = ytPlayer.getCurrentTime() || 0;
        var idx     = typeof ytPlayer.getPlaylistIndex === 'function'
                      ? ytPlayer.getPlaylistIndex() : -1;
        sessionStorage.setItem(STATE_KEY, JSON.stringify({
          videoId: videoId, t: t, idx: idx, savedAt: Date.now()
        }));
      } catch (_) {}
    }

    function _readYtState() {
      try {
        var raw = sessionStorage.getItem(STATE_KEY);
        if (!raw) return null;
        var s = JSON.parse(raw);
        if (!s || !s.savedAt) return null;
        if (Date.now() - s.savedAt > STATE_TTL_MS) {
          sessionStorage.removeItem(STATE_KEY);
          return null;
        }
        return s;
      } catch (_) { return null; }
    }

    function _restoreYtState(player) {
      var s = _readYtState();
      if (!s) return false;
      try {
        if (s.idx != null && s.idx >= 0) {
          /* Prefer playlist-index-based restore so subsequent tracks
             keep cycling through the playlist after this one ends.
             seekTo is deferred 250ms so the API has time to actually
             load the indexed track before we seek inside it. */
          player.playVideoAt(s.idx);
          setTimeout(function () {
            try { player.seekTo(s.t, true); } catch (_) {}
          }, 250);
        } else if (s.videoId) {
          player.loadVideoById({ videoId: s.videoId, startSeconds: s.t });
        }
        return true;
      } catch (_) { return false; }
    }

    /* Save handlers — wired BEFORE the player so we don't miss saves. */
    window.addEventListener('pagehide', _saveYtState);
    window.addEventListener('beforeunload', _saveYtState);
    document.addEventListener('visibilitychange', function () {
      if (document.visibilityState === 'hidden') _saveYtState();
    });
    setInterval(function () { if (isPlaying) _saveYtState(); }, 4000);

    /* ── Music player: feeds the NOW PLAYING widget ── */
    ytPlayer = new YT.Player('bios-yt-player', {
      height: '1',
      width:  '1',
      videoId: 'aQVHyJDf-kY', /* seed track for the radio mix */
      playerVars: {
        listType:       'playlist',
        list:           PLAYLIST_ID,
        autoplay:       1,
        loop:           1,
        controls:       0,
        disablekb:      1,
        fs:             0,
        modestbranding: 1,
        playsinline:    1,
        rel:            0,
      },
      events: {
        onReady: function (e) {
          window._biosYtPlayer = e.target;
          e.target.setVolume(typeof volPct !== 'undefined' ? volPct : 10);
          /* Try restoring playback state from sessionStorage first.
             If a saved state exists from a prior page within this tab,
             _restoreYtState() calls playVideoAt + seekTo (or loadVideoById)
             so the music resumes at the same track + timestamp. If
             nothing's saved (fresh tab), fall through to fresh playback. */
          var restored = (typeof _restoreYtState === 'function') && _restoreYtState(e.target);
          if (!restored) e.target.playVideo();
          /* notify mixer (and any other listener) that music is ready */
          document.dispatchEvent(new CustomEvent('bios:yt-player-ready'));
        },
        onStateChange: function (e) {
          isPlaying = (e.data === YT.PlayerState.PLAYING);
          if (ppBtn) ppBtn.textContent = isPlaying ? '\u23F8' : '\u25B6';
          if (e.data === YT.PlayerState.PLAYING) updateTrack();
          /* autoplay blocked — show nudge in track display */
          if (e.data === YT.PlayerState.UNSTARTED || e.data === -1) {
            if (trackEl) trackEl.textContent = 'CLICK TO ENABLE AUDIO';
          }
        },
        onError: function () {
          if (trackEl) trackEl.textContent = 'UPLINK ERROR';
        }
      }
    });
  };

  /* on first interaction, try to start both players if autoplay was blocked */
  var started = false;
  function tryStart() {
    if (started) return;
    started = true;
    if (ytPlayer && typeof ytPlayer.getPlayerState === 'function') {
      var state = ytPlayer.getPlayerState();
      if (state !== YT.PlayerState.PLAYING) ytPlayer.playVideo();
    }
    if (ytAmbient && typeof ytAmbient.getPlayerState === 'function') {
      var aState = ytAmbient.getPlayerState();
      if (aState !== YT.PlayerState.PLAYING) ytAmbient.playVideo();
    }
  }
  ['click', 'keydown', 'touchstart'].forEach(function (ev) {
    document.addEventListener(ev, tryStart, { once: true, passive: true });
  });

  /* ── Music ducking — BiosAudio.duckMusic(mult, ms) calls this so the
       checkout modem handshake plays clean over a halved music gain. ── */
  window._biosPlayerDuck = function (targetMult, durMs) {
    if (!ytPlayer || typeof ytPlayer.getVolume !== 'function') return;
    var orig = ytPlayer.getVolume();
    var target = Math.max(0, Math.min(100, Math.round(orig * targetMult)));
    try { ytPlayer.setVolume(target); } catch (_) {}
    setTimeout(function () {
      try { ytPlayer.setVolume(orig); } catch (_) {}
    }, durMs || 1100);
  };

  /* ── Mobile pip: sync state with YouTube player ── */
  (function initMobilePip() {
    var pipEl    = document.getElementById('bios-mobile-pip');
    var pipTrack = document.getElementById('bios-mobile-pip-track');
    var pipBtn   = document.getElementById('bios-mobile-pip-btn');
    var pipBarsEl = document.getElementById('bios-mobile-pip-bars');
    var pipBarSpans = pipBarsEl ? Array.prototype.slice.call(pipBarsEl.querySelectorAll('span')) : [];
    if (!pipEl) return;

    var _pipPlaying = false;
    var _pipPhase   = 0;

    /* pip bars mirror the desktop visualizer's shared band levels (_biosVizBands).
       The 5 pip spans map to 5 evenly-spaced samples across the 10 desktop bands. */
    (function pipBarLoop() {
      requestAnimationFrame(pipBarLoop);
      var bands = window._biosVizBands;
      if (!_pipPlaying || !bands) {
        pipBarSpans.forEach(function(bar) { bar.style.height = '2px'; });
        return;
      }
      pipBarSpans.forEach(function(bar, i) {
        /* sample indices: 0, 2, 4, 6, 8 across the 10 bands */
        var lvl = bands[i * 2] || 0;
        /* remap 0-10 to 2-18px */
        var h = Math.round(2 + lvl * 1.6);
        bar.style.height = h + 'px';
      });
    })();

    /* sync playing state */
    function syncPip(playing, title) {
      _pipPlaying = playing;
      pipEl.classList.toggle('is-playing', playing);
      if (pipBtn) pipBtn.textContent = playing ? '\u23F8' : '\u25B6';
      if (pipTrack) {
        var t = (title || '——').toUpperCase();
        pipTrack.textContent = t.length > 26 ? t.slice(0, 25) + '\u2026' : t;
      }
    }

    /* tap pip to toggle play/pause */
    pipEl.addEventListener('click', function() {
      if (!ytPlayer || typeof ytPlayer.getPlayerState !== 'function') return;
      if (ytPlayer.getPlayerState() === YT.PlayerState.PLAYING) {
        ytPlayer.pauseVideo();
      } else {
        ytPlayer.playVideo();
      }
    });

    /* poll state every 900ms */
    setInterval(function() {
      if (!ytPlayer || typeof ytPlayer.getVideoData !== 'function') return;
      var playing = ytPlayer.getPlayerState() === YT.PlayerState.PLAYING;
      var data    = ytPlayer.getVideoData() || {};
      syncPip(playing, data.title || (playing ? 'NOW PLAYING' : '——'));
    }, 900);
  })();

  /* inject YouTube IFrame API script */
  var tag = document.createElement('script');
  tag.src = 'https://www.youtube.com/iframe_api';
  document.head.appendChild(tag);
})();
